<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Season of Sacrifice</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<h2 class="chapter-number">ACKNOWLEDGMENTS</h2>
<p class="flush-left-opener"><span class="big">W</span>arm thanks go to those who stood by me during the creation of this book. Their names (in no particular order) are: Kimberly Ito, Debra Borchert, Elena Hartwell, Tami Euliano, Christine Mason, and Gail Kretchmer. Their optimism and suggestions have helped give life to this project.</p>
<p class="indented">I am also fortunate to have a stellar publishing team. Priya Doraswamy, agent nonpareil, is always supportive and always a pleasure to work with. Everyone at Severn House has given enormous care and thought to this task. I’ll forever be grateful to all of you.</p>
<p class="indented">I am deeply appreciative of my scientist friends whose knowledge has informed the premise of my story. Special thanks go to Mike Hawley, who patiently answered my questions about police procedures. And to 4Culture for a grant that partially supported this project.</p>
<p class="indented">To those not directly connected with my efforts, but who have sustained me over the years, I say thank you. Shau-lee Chow for the trips to the shows and for always having a spirit of joy. Rekha Sood and Santosh Wahi for leisurely lunches and sisterhood. Lakshmi Gaur for wide-ranging conversations that kept me centered whenever we could catch a few moments. Lalitha Uppala for being there. Elizabeth George for somehow managing to find time for tea and shop talk. Deepa Banerjee, Librarian at the University of Washington, for her confidence in me.</p>
<p class="indented">And, finally, to my husband Tom for his love, support and encouragement. You ultimately made this possible.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter000.vue?f8ff0c60